import * as React from 'react';

import {ReportState} from "../../ReportsEnums";
import {ReportsFilteringListProps} from "./ReportsFiltering";
import './ReportsFiltering.scss';

const ReportsFilteringSelect: React.FunctionComponent<ReportsFilteringListProps> = props => {
	const {setFilterCallback,doneTitle,ongoingTitle,awaitingTitle,archivedTitle,activeStateFilter} = props;
	const enumMap = [ReportState.Done,ReportState.Ongoing,ReportState.AwaitingApproval,ReportState.Archived];
	const onChange = (e:React.ChangeEvent<HTMLSelectElement>)=>{
		setFilterCallback(enumMap[parseInt(e.currentTarget.value)]);
	};
	return (
		<div className='ReportsFiltering ReportsFilteringSelect'>
			<select value={activeStateFilter} className='ReportsFilteringSelect__Select' onChange={onChange}>
				<option value={0}>{doneTitle}</option>
				<option value={1}>{ongoingTitle}</option>
				<option value={2}>{awaitingTitle}</option>
				<option value={3}>{archivedTitle}</option>
			</select>
		</div>
	);
};

export default ReportsFilteringSelect;
